import { gql } from '@apollo/client';

export const CreateSeason = gql`
  mutation CreateSeason($data: SeasonCreateInput!) {
    createSeason(data: $data) {
      id
      name
      startDate
      endDate
    }
  }
`;
